import containerFuild from '../html-snippets/container-fuild';
import cssSnippet from '../css-snippets/section-card-compare-yuri';
const html = `
<div data-max-width="700" data-enable-border="true" data-color-border="#e5e7eb" data-attribute="wrap-card"
  class="wrap-card" style="--border-color:#e5e7eb; --max-width-wrap: 700px">
  <div data-show="true" data-attribute="title-card" class="title-card">
    <h2 style="text-align:center;">Instantly transform your <span style="color:#e64c4c;"><i>skin</i></span>
    </h2>
    <p style="text-align:center;">See visible results after just one use. Our formula drastically reduces dead skin,
      boosts radiance, and smooths rough texture - leaving your skin soft, glowing, and renewed.</p>
  </div>
  <div>
    <div data-attribute="card-content" class="card-content">
      <div class="img-comp-container">
        <div class="img-comp-img" style="width: 100%;">
          <img loading="lazy" data-attribute="image-after"
            src="https://cdn.skyfastimg.com/images/2026/05/06/image-69faa373294e499cb423d4c1.webp">
        </div>
        <div class="img-comp-slider"></div>
        <div class="img-comp-img img-comp-overlay">
          <img loading="lazy" data-attribute="image-before" src="https://cdn.skyfastimg.com/images/2026/05/06/image-69faa373294e499cb423d4c1.webp">
        </div>
        <div class="before-and-after">
          <div data-attribute="before" data-background="#000000" data-color="#ffffff" class="before"
            style="background-color: #000000; color: #ffffff;">Before</div>
          <div data-attribute="after" data-background="#00000011" data-color="#ffffff" class="after"
            style="background-color: #00000000; color: #ffffff;">After</div>
        </div>
      </div>
    </div>
    <div data-attribute="explication" data-show="true" class="explication">
      <p>See visible results after just one use. Our formula drastically reduces dead skin, boosts radiance, and smooths
        rough texture - leaving your skin soft, glowing, and renewed.</p>
    </div>
  </div>
</div>
`;
export default containerFuild(html, cssSnippet);
